module.exports = __webpack_public_path__ + "static/media/header-transparent.a1c0bff8.png";